export const wrapStyle = {
  minWidth: 0,
  overflow: 'hidden',
};

export const boardStyle = (sliding, direction, isMobile = false) => ({
  display: 'grid',
  gridTemplateColumns: isMobile ? 'minmax(0, 1fr)' : 'repeat(3, minmax(0, 1fr))',
  gap: 10,
  minWidth: 0,
  opacity: sliding ? 0.72 : 1,
  transform: sliding ? `translateX(${direction === 'next' ? '-22px' : '22px'})` : 'translateX(0)',
  transition: 'transform 260ms ease, opacity 260ms ease',
});

export const monthCardStyle = {
  minWidth: 0,
  border: '1px solid var(--border)',
  borderRadius: 10,
  background: 'var(--bg-card)',
  overflow: 'hidden',
};

export const calendarStyle = {
  borderBottom: '1px solid var(--border)',
};

export const monthTitleStyle = {
  padding: '8px 10px',
  fontSize: 13,
  fontWeight: 900,
  color: 'var(--text)',
  background: 'rgba(37,99,235,0.07)',
};

export const weekdayGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
  borderBottom: '1px solid var(--border)',
};

export const weekdayStyle = {
  padding: '5px 0',
  textAlign: 'center',
  fontSize: 10,
  fontWeight: 800,
  color: 'var(--text-sub)',
};

export const sundayWeekdayStyle = {
  color: '#dc2626',
};

export const saturdayWeekdayStyle = {
  color: '#2563eb',
};

export const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
};

export const cellStyle = {
  minHeight: 46,
  minWidth: 0,
  padding: 4,
  borderRight: '1px solid var(--border)',
  borderBottom: '1px solid var(--border)',
  boxSizing: 'border-box',
};

export const emptyCellStyle = {
  ...cellStyle,
  background: 'rgba(148,163,184,0.06)',
};

export const sundayCellStyle = {
  background: 'rgba(220,38,38,0.045)',
};

export const saturdayCellStyle = {
  background: 'rgba(37,99,235,0.045)',
};

export const holidayCellStyle = {
  background: 'rgba(220,38,38,0.08)',
};

export const currentWeekStyle = {
  boxShadow: 'inset 0 0 0 2px rgba(37,99,235,0.38)',
};

export const todayStyle = {
  background: 'rgba(245,158,11,0.12)',
};

export const dateRowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 3,
  minWidth: 0,
};

export const dayStyle = (isSunday, isSaturday, isHoliday) => ({
  flex: '0 0 auto',
  fontSize: 10,
  fontWeight: 900,
  color: isHoliday || isSunday ? '#dc2626' : isSaturday ? '#2563eb' : 'var(--text)',
});

export const holidayStyle = {
  flex: '1 1 auto',
  minWidth: 0,
  fontSize: 9,
  lineHeight: 1.1,
  color: '#b91c1c',
  fontWeight: 900,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const nameStyle = (hasName) => ({
  marginTop: 5,
  minHeight: 18,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 5,
  background: hasName ? '#2563eb' : 'rgba(148,163,184,0.22)',
  color: hasName ? '#fff' : 'var(--text-sub)',
  fontSize: 10,
  fontWeight: 900,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const mobileAssignmentListStyle = {
  display: 'grid',
  gap: 8,
  padding: 10,
  background: 'var(--bg-card)',
  borderBottom: '1px solid var(--border)',
};

export const mobileWeekCardStyle = {
  display: 'grid',
  gap: 8,
  padding: 10,
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'rgba(148,163,184,0.06)',
};

export const mobileWeekDateStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  color: 'var(--text)',
  fontSize: 13,
};

export const mobileWeekSelectStyle = {
  width: '100%',
  height: 38,
  border: '1px solid var(--border)',
  borderRadius: 7,
  background: 'var(--bg-card)',
  color: 'var(--text)',
  padding: '0 9px',
  boxSizing: 'border-box',
  fontSize: 14,
};

export const mobileWeekActionsStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: 8,
};

export const mobileIconButtonStyle = (bg, disabled) => ({
  height: 36,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 5,
  border: 'none',
  borderRadius: 7,
  color: '#fff',
  background: disabled ? '#9ca3af' : bg,
  fontSize: 13,
  fontWeight: 900,
  cursor: disabled ? 'not-allowed' : 'pointer',
});

export const noteStyle = {
  padding: 8,
  background: 'rgba(148,163,184,0.06)',
};

export const noteHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  marginBottom: 6,
  fontSize: 11,
  fontWeight: 900,
  color: 'var(--text-sub)',
};

export const textareaStyle = {
  width: '100%',
  height: 48,
  resize: 'none',
  border: '1px solid var(--border)',
  borderRadius: 7,
  background: 'var(--bg-card)',
  color: 'var(--text)',
  padding: '7px 8px',
  boxSizing: 'border-box',
  fontSize: 12,
  lineHeight: 1.35,
};

export const noteButtonStyle = (disabled) => ({
  height: 26,
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  border: 'none',
  borderRadius: 6,
  padding: '0 8px',
  color: '#fff',
  background: disabled ? '#9ca3af' : '#2563eb',
  fontSize: 11,
  fontWeight: 900,
  cursor: disabled ? 'not-allowed' : 'pointer',
});
